import { useState } from 'react';
import { Tabs, TabList, Tab, TabPanel, Key } from 'react-aria-components';

export const Page = () => {
  const [activeTab, setActiveTab] = useState<Key>('basic');
  return (
    <>
      <Tabs
        className="flex flex-col"
        selectedKey={activeTab}
        onSelectionChange={setActiveTab}
      >
        <TabList className="flex border-b-2">
          <Tab
            id="basic"
            className={`p-2 px-6 font-bold ${activeTab === 'basic' ? 'border-b-4 border-blue-700 text-blue-700' : 'text-gray-300'}`}
          >
            基本情報
          </Tab>
          <Tab
            id="external"
            className={`p-2 px-6 font-bold ${activeTab === 'external' ? 'border-b-4 border-blue-700 text-blue-700' : 'text-gray-300'}`}
          >
            外部連携先
          </Tab>
          <Tab
            id="recipient"
            className={`p-2 px-6 font-bold ${activeTab === 'recipient' ? 'border-b-4 border-blue-700 text-blue-700' : 'text-gray-300'}`}
          >
            需給者情報
          </Tab>
          <Tab
            id="else"
            className={`p-2 px-6 font-bold ${activeTab === 'else' ? 'border-b-4 border-blue-700 text-blue-700' : 'text-gray-300'}`}
          >
            その他
          </Tab>
        </TabList>
        <TabPanel id="basic">Arma virumque cano, Troiae qui primus ab oris.</TabPanel>
        <TabPanel id="external">Senatus Populusque Romanus.</TabPanel>
        <TabPanel id="recipient">Alea jacta est.</TabPanel>
        <TabPanel id="else"></TabPanel>
      </Tabs>
    </>
  );
};
